/**
 * Serwis dla Granic Ceny (Minimalna Marża)
 */

import api from './api';

export const priceLimitsService = {
  // =====================================================
  // USTAWIENIA GLOBALNE
  // =====================================================

  /**
   * Pobierz ustawienia granicy ceny dla lokalizacji
   */
  async getSettings(locationId) {
    try {
      const response = await api.get(`/products/price-limits/settings/${locationId}`);
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania ustawień granic ceny:', error);
      return { success: false, error: error.message };
    }
  },

  /**
   * Zapisz ustawienia granicy ceny
   */
  async saveSettings(locationId, settings) {
    try {
      const response = await api.put(`/products/price-limits/settings/${locationId}`, settings);
      return response.data;
    } catch (error) {
      console.error('Błąd zapisywania ustawień:', error);
      return { success: false, error: error.message };
    }
  },

  // =====================================================
  // WYJĄTKI DLA PRODUKTÓW
  // =====================================================

  /**
   * Pobierz listę wyjątków
   */
  async getExceptions(locationId) {
    try {
      // Używamy debug endpoint który działa, i filtrujemy po location_id
      const response = await api.get('/products/price-limits/debug');
      if (response.data.success && response.data.data) {
        const allExceptions = response.data.data.exceptions_join || [];
        const filtered = allExceptions.filter(e => e.location_id === locationId);
        return { success: true, data: filtered };
      }
      return { success: false, data: [] };
    } catch (error) {
      console.error('Błąd pobierania wyjątków:', error);
      return { success: false, error: error.message, data: [] };
    }
  },

  /**
   * Dodaj/aktualizuj wyjątek
   */
  async addException(locationId, productId, minMarginPercent, reason = '', createdBy = null) {
    try {
      const response = await api.post(`/products/price-limits/exceptions/${locationId}`, {
        product_id: productId,
        min_margin_percent: minMarginPercent,
        reason,
        created_by: createdBy
      });
      return response.data;
    } catch (error) {
      console.error('Błąd dodawania wyjątku:', error);
      return { success: false, error: error.message };
    }
  },

  /**
   * Usuń wyjątek
   */
  async deleteException(locationId, exceptionId) {
    try {
      const response = await api.delete(`/products/price-limits/exceptions/${locationId}/${exceptionId}`);
      return response.data;
    } catch (error) {
      console.error('Błąd usuwania wyjątku:', error);
      return { success: false, error: error.message };
    }
  },

  /**
   * Dodaj wiele wyjątków naraz
   */
  async bulkAddExceptions(locationId, products, createdBy = null) {
    try {
      const response = await api.post(`/products/price-limits/exceptions/${locationId}/bulk`, {
        products,
        created_by: createdBy
      });
      return response.data;
    } catch (error) {
      console.error('Błąd masowego dodawania wyjątków:', error);
      return { success: false, error: error.message };
    }
  },

  // =====================================================
  // WALIDACJA
  // =====================================================

  /**
   * Waliduj pojedynczą cenę
   */
  async validatePrice(locationId, productId, proposedPrice, purchasePrice = null) {
    try {
      const response = await api.post('/products/price-limits/validate', {
        location_id: locationId,
        product_id: productId,
        proposed_price: proposedPrice,
        purchase_price: purchasePrice
      });
      return response.data;
    } catch (error) {
      console.error('Błąd walidacji ceny:', error);
      return { success: false, error: error.message };
    }
  },

  /**
   * Waliduj cały koszyk przed finalizacją
   */
  async validateCart(locationId, items) {
    try {
      const response = await api.post('/products/price-limits/validate-cart', {
        location_id: locationId,
        items: items.map(item => ({
          product_id: item.id || item.product_id || item.produkt_id,
          price: item.price || item.cena || item.cena_jednostkowa,
          purchase_price: item.purchase_price || item.cena_zakupu || item.current_purchase_price
        }))
      });
      return response.data;
    } catch (error) {
      console.error('Błąd walidacji koszyka:', error);
      return { success: false, error: error.message };
    }
  }
};

export default priceLimitsService;
